import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, Tabs} from 'react-bootstrap';
import Stock from 'inventory/Stock';
import CheckStock from 'inventory/CheckStock';
import jwt_decode from "jwt-decode";

class ManageStock extends Component {
    constructor(props){
        super(props);
        this.state = {
            userType:'',
            tabShow:false
        }

    }
    componentDidMount() {

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(decoded.userGroupName);
            if(decoded.userGroupName ==='Distributor')
            {
                this.setState({
                    tabShow: true
                    });
            }
        this.setState(
            {
                userType:decoded.userType
            }
        )
    }
    handleSelectTab(key, e) {

    }
    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Manage Stocks</h4>
                                    <p className="category"></p>
                                </div>
                                <div className="content">
                                    <React.Fragment>
                                        <Tabs defaultActiveKey="showStocks" id="query-builder-tab" onSelect={this.handleSelectTab.bind(this)} >
                                            <Tab eventKey="showStocks" title="Show Stocks" >
                                                <Stock/>
                                            </Tab>
                                            <Tab eventKey="checkStocks" title="Check Stocks" disabled={this.state.tabShow} >
                                                <CheckStock/>
                                            </Tab>
                                        </Tabs>
                                    </React.Fragment>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ManageStock;
